module.exports = "/_next/static/images/instrument_5-303a3d790b1f87eb13cd5500249b83a6.png";